/**
 * @name hasOverflow
 *
 * @description Returns a true if the given element is overflowing on either the y- or x-axis
 *
 * @example
 * import { hasOverflow } from '@workbench/core';
 *
 * const hasOverflow: boolean = hasOverflow(someElement);
 */
export const hasOverflow = (element: HTMLElement): boolean => {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};
